import type DrawerManager from "@components/Drawer/DrawerManager";

import { BRANDING_WIDGET_TYPES } from "../modules/StorefrontValues/constants";
import type { BrandingWidgetType } from "../modules/StorefrontValues/types";
import type RewardsPopUpWidgetLauncherManager from "../widgets/rewards_popup_widget/utils/RewardsPopUpWidgetLauncherManager/RewardsPopUpWidgetLauncherManager";

export const showPopUpOrDrawerWidget = ({
    widgetType,
    launcherManager,
    drawerManager,
}: {
    widgetType: BrandingWidgetType;
    launcherManager: RewardsPopUpWidgetLauncherManager;
    drawerManager: DrawerManager;
}): void => {
    if (widgetType === BRANDING_WIDGET_TYPES.popUpWidget) {
        launcherManager.rewardsPopUpWidgetShow();
    } else {
        drawerManager.drawerShow();
    }
};
